import { boolean, nullish, number, object } from 'valibot'
import { responseParamsSchema } from './params'

export const headersSchema = object({
  zkConnected: nullish(boolean()),
  status: number(),
  QTime: number(),
  params: responseParamsSchema,
})
